module.exports = " <div :style={margin:gap}><slot></slot></div> ";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.3@vue-html-loader!./~/.8.7.0@vue-loader/lib/selector.js?type=template&index=0!./~/.0.1.3@vux/src/components/box/index.vue
// module id = 203
// module chunks = 2